import AvatarGroup, { AvatarGroupItems } from "./AvatarGroup";

export default AvatarGroup;
export type {AvatarGroupItems}